import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import PageLayout from './App/Pages/PageLayoutWrapper';
import { store } from './Store';
import { ThemeProvider } from '@fluentui/react';
import * as serviceWorker from './serviceWorker';
import { initWebVitalsTracking } from './utils/webVitalsTracker';
import { registerIcons  } from '@fluentui/react/lib/Styling';
import { DatabaseViewIcon , ResetIcon } from '@fluentui/react-icons-mdl2';
import CopilotBetaIcon from 'src/manageAction/components/molecules/ActionDetailsRightContainer/CopilotSection/svgs/CopilotBeta-Colored.svg?react';
import HomeIcon from 'src/left-navigation/images/home.svg?react';
import ManageIcon from 'src/left-navigation/images/manage.svg?react';
import MyDashboardIcon from 'src/left-navigation/images/view-dashboard.svg?react';
import UnknownIcon from 'src/icons/Unknown.svg?react';
import CaseTrackingCancelled from 'src/Components/CaseTracking/CaseTrackingIconSvg/Cancelled.svg?react';
import CaseTrackingCompleted from 'src/Components/CaseTracking/CaseTrackingIconSvg/Completed.svg?react';
import CaseTrackingInProgress from 'src/Components/CaseTracking/CaseTrackingIconSvg/InProgress.svg?react';
import CaseTrackingNotStarted from 'src/Components/CaseTracking/CaseTrackingIconSvg/NotStarted.svg?react';
import ChevronRightSlim from 'src/Components/CaseTracking/CaseTrackingIconSvg/ChevronRightSlim.svg?react';

registerIcons({
  icons: {
    DatabaseViewIconNew: <DatabaseViewIcon />,
    CopilotRewriteIcon: <CopilotBetaIcon />,
    HomeIcon: <HomeIcon />,
    ManageIcon: <ManageIcon />,
    MyDashboardIcon: <MyDashboardIcon />,
    UnknownIcon: <UnknownIcon />,
    ResetIcon: <ResetIcon />,
    CaseTrackingCompleted : <CaseTrackingCompleted />,
    CaseTrackingInProgress : <CaseTrackingInProgress />,
    CaseTrackingCancelled : <CaseTrackingCancelled />,
    CaseTrackingNotStarted : <CaseTrackingNotStarted />,
    ChevronRightSlim: <ChevronRightSlim />,
  },
});

ReactDOM.render(
  <ThemeProvider>
    <Provider store={store}>
      <Router>
        <PageLayout />
      </Router>
    </Provider>
  </ThemeProvider>,
  document.getElementById('root') as HTMLElement
);

// Initialize Web Vitals tracking (LCP, CLS, INP, FCP, FID, TTFB)
initWebVitalsTracking();

serviceWorker.unregister();
// Generated by GitHub Copilot | Updated on: 2026-05-19 | 3 lines modified | Added Web Vitals initialization import and call
